<template>
  <div class="image-card pointer" :style="`background-image: url('${url}'); aspect-ratio: ${ratio} `"></div>
</template>

<script>
export default {
  props: ["url", "ratio",],
  components: {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.image-card {
  border-radius: 8px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  background-color: lightgrey;
  /* height: 100%; */
  /* width: auto; */
}
</style>
